import React, { useMemo } from 'react';
import { useTheme } from './ThemeContext';

export const useThemedStyles = () => {
  const { tokens } = useTheme();

  return useMemo(() => {
    const page: React.CSSProperties = {
      minHeight: '100%',
      background: tokens.app.background,
      color: tokens.app.text
    };
    const card: React.CSSProperties = {
      background: tokens.app.surface,
      color: tokens.app.text,
      border: `1px solid ${tokens.app.border}`,
      borderRadius: 8,
      boxShadow: tokens.app.shadow
    };
    const panel: React.CSSProperties = {
      background: tokens.app.subtle,
      color: tokens.app.text,
      border: `1px solid ${tokens.app.border}`,
      borderRadius: 8
    };
    const input: React.CSSProperties = {
      background: tokens.app.input,
      color: tokens.app.text,
      border: `1px solid ${tokens.app.inputBorder}`,
      borderRadius: 6,
      colorScheme: tokens.isLight ? 'light' : 'dark'
    };
    const inputStrong: React.CSSProperties = {
      ...input,
      border: `2px solid ${tokens.app.inputBorder}`
    };
    const button: React.CSSProperties = {
      background: tokens.app.primary,
      color: tokens.app.primaryText,
      border: `1px solid ${tokens.app.primary}`,
      borderRadius: 6,
      cursor: 'pointer',
      fontWeight: 600
    };
    const secondaryButton: React.CSSProperties = {
      background: tokens.app.surfaceAlt,
      color: tokens.app.text,
      border: `1px solid ${tokens.app.border}`,
      borderRadius: 6,
      cursor: 'pointer',
      fontWeight: 600
    };
    const tableHeader: React.CSSProperties = {
      background: tokens.app.surface,
      color: tokens.app.text
    };
    const tableRow: React.CSSProperties = {
      borderBottom: `1px solid ${tokens.app.border}`,
      color: tokens.app.text
    };

    return {
      tokens,
      page,
      card,
      panel,
      input,
      inputStrong,
      button,
      secondaryButton,
      tableHeader,
      tableRow,
      text: tokens.app.text,
      muted: tokens.app.muted,
      border: tokens.app.border,
      surface: tokens.app.surface,
      surfaceAlt: tokens.app.surfaceAlt,
      inputBg: tokens.app.input,
      primary: tokens.app.primary,
      primaryText: tokens.app.primaryText,
      activeBg: tokens.app.activeBg,
      activeText: tokens.app.activeText,
      subtle: tokens.app.subtle,
      shadow: tokens.app.shadow
    };
  }, [tokens]);
};
